import { openApi } from '@/api/request'
import { gioTracking } from "@/utilities/tools"

export default {
  getCruiseFilter () {
    const url = '/Rccl.OpenApi/cruise/GetCruiseFilterHomePage'
    return openApi.get(url)
  },
  setCruiseFilter (data) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseFilterV2', {
      params: {
        shipCode: data.shipCode,
        sailDate: data.sailDate,
        sailDays: data.sailDays,
        departureCodes: data.departureCodes,
        destinationCodes: data.destinationCodes,
        tags: data.tags,
        cruiseSearchType: data.cruiseSearchType,
        isAgency: data.isAgency || false,
      }
    })
  },
  cruiseSearch (data) {
    let hotTags = '';
    if (data.tags) {
      hotTags += data.tags;
    }
    if (data.keywords) {
      hotTags += data.tags ? `,${data.keywords}` : data.keywords;
    }
    gioTracking('track', 'evt_Filter', {
      port:data.departureCodes || 'nil',
      departureDate:data.sailDate || 'nil',
      shipCode:data.shipCode || 'nil',
      destination:data.destinationCodes || 'nil',
      sailingNight:data.sailDays || 'nil',
      hotTags: hotTags || 'nil'
    })
    return openApi.get('/Rccl.OpenApi/Cruise/CruiseSearchApi', {
      params: {
        shipCodes: data.shipCode,
        sailDates: data.sailDate,
        sailDays: data.sailDays,
        departureCodes: data.departureCodes,
        destinationCodes: data.destinationCodes,
        tags: data.tags,
        keywords: data.keywords || '',
        cruiseSearchType: data.cruiseSearchType,
        username: data.username,
        tagSource: 'online',
        offset: data.offset || 0,
        limit: data.limit || 10,
        isAgency: data.isAgency || false,
        orderBysailDate: data.orderBysailDate,
        orderByPrice: data.orderByPrice,
        orderBySailDays: data.orderBySailDays,
        orderByAmountPerNight: data.orderByAmountPerNight,
        orderByPopular: data.orderByPopular,
        includeSoldOut: data.includeSoldOut,
        includeAgency: data.includeAgency,
      }
    })
  },
  getCruiseByRoute (routeCode) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetCruiseByrouteCode', {routeCode, isRow: false})
  },
  getCruiseSearchPage () {
    return openApi.post('/Rccl.OpenApi/Cruise/GetCruiseSearchView')
  },
  addWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/AddCruiseWishList', requestData)
  },
  deleteWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/DeleteCruiseWishList', requestData)
  },
  isInWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/IsInWishListHP', requestData)
  },
  getWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetAll', requestData)
  },
  getCruiseDetail (requestData) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseDetailHP', {
      params: requestData
    })
  },
  getStateroomCategory (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/GetAllStateroomCategoryApiHP', requestData)
  },
  getMaxAdultAndChildCount (requestData) {
    return openApi.post('/Rccl.OpenApi/StateroomRecommendation/GetMaxAdultAndChildCount', requestData)
  },
  getRecommendedRoomsByGuestCount (requestData) {
    return openApi.post('/Rccl.OpenApi/StateroomRecommendation/GetRecommendedRoomsByGuestCount', requestData)
  },
  getShorexByCity (requestData) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetShorexIntroByCity', {
      params: requestData
    })
  },
  getCruiseReview(requestData) {
    return openApi.post('/Rccl.OpenApi/TUITravel/GetReviews', requestData)
  },
  searchKeywordTips (requestData) {
    return openApi.get('/Rccl.OpenApi/Cruise/SearchFuzzyMatchingApi', {
      params: requestData
    })
  },
  getPromoCruiseHP ({userName, plateform, isRow, type, shipCode, relatedCruiseIds, cruiseIds}) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetPromoCruiseHPApi', {
      userName,
      plateform,
      isRow,
      type,
      shipCode,
      relatedCruiseIds,
      cruiseIds
    })
  },
  getAllCruiseFeature() {
    return openApi.post('/Rccl.OpenApi/Cruise/GetAllCruiseFeature')
  },
  getShipVrMiniSiteApi(requestData){
    return openApi.get('/Rccl.OpenApi/PanoramicVR/GetPanoramicVRApi', {
      params:requestData
    })
  },
  getCruiseBannerApi(data) {
    return openApi.get('/Rccl.OpenApi/Cruise/CruiseBannerApi',{
      params:{
        businessType:data.businessType
      }
    })
  },
  getOutOfStockInfo(requestData) {
    return openApi.post('/Rccl.OpenApi/OutOfStockApi/SearchOutOfStock', requestData)
  },
  submitOutOfStock(requestData) {
    return openApi.post('/Rccl.OpenApi/OutOfStockApi/SubmitOutOfStock', requestData)
  }
}
